export const memberProfile = {
  "verified": "Verificado",
  "online": "En línea",
  "memberSince": "Miembro desde",
  "contact": "Contactar",
  "share": "Compartir",
  "respondsIn": "Responde en",
  "responseRate": "de respuesta",
  "exchangesCompleted": "Intercambios realizados",
  "reviews": "reseñas",
  "responseRateLabel": "Tasa de respuesta",
  "memberSinceLabel": "Miembro desde",
  "years": "años",
  "year": "año",
  "exchangeHistory": "Historial de intercambios",
  "property": "Alojamiento",
  "reviewsTab": "Reseñas",
  "all": "Todos",
  "completed": "Completados",
  "upcoming": "Próximos",
  "cancelled": "Cancelado",
  "exchangeWith": "Intercambio con",
  "nights": "noches",
  "noExchangeInCategory": "Ningún intercambio en esta categoría",
  "offeredProperty": "Alojamiento ofrecido",
  "memberReviews": "Reseñas de miembros"
};
